import { ISetOwnerParams } from '~src/spacesPlatform/utils/actionParams';

import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export class SetProjectsOwnerRequest extends Request<ISetOwnerParams, IResult> {
  constructor(ids: string[], ownerId: string) {
    super('setProjectsOwner', {
      ids: ids,
      ownerId: ownerId
    });
  }
}
